

jQuery(function($){

    if ($('.offertemand-page').length == 0){
        return;
    }
    

    function initCart(){
        //updateCartSummary();
        updateCartControls();
        updateCart();
        updateCartCount();   
    }


    initCart();


    function updateCart(){
        $.ajax({
            url: wemake.ajax_url, 
            type: 'GET',
            data: {
                action: 'get_cart_html', 
                _wpnonce: wemake.nonce,
            },
            beforeSend: function(){
               // $('.cart').html('<div class="spinner-loader"></div>');
            },
            success: function(response){
                $('.cart').html(response.data);                
            },
        });
    }

    function updateCartSummary(){
        $.ajax({
            url: wemake.ajax_url, 
            type: 'GET',
            data: {
                action: 'get_cart_summary_html', 
                _wpnonce: wemake.nonce,
            },

            beforeSend: function(){
              //  $('.cart__summary').html('<div class="spinner-loader"></div>');
            },

            success: function(response){
                $('.cart__summary').html(response.data);
            },

            error: function(error) {
                console.error('Error displaying summary:', error);
            }
        });  
    }

    function updateCartControls(){
        $.ajax({
            url: wemake.ajax_url, 
            type: 'GET',
            data: {
                action: 'get_cart_controls_html', 
                _wpnonce: wemake.nonce,
            },

            success: function(response){
                $('.cart__controls').html(response.data);
            },

            error: function(error) {
                console.error('Error displaying summary:', error);
            }
        });
    }

    function updateCartTitle(){
        $.ajax({
            url: wemake.ajax_url, 
            type: 'GET',
            data: {
                action: 'get_cart_title', 
                _wpnonce: wemake.nonce,
            },

            success: function(response){
                $('.cart__title h1').html(response.data);
                $('.header__cart-title').text(response.data);
                $('.cart__checkout-btn').text(response.data == 'Winkelwagen' ? 'Ga naar afrekenen' : 'Vraag offerte aan');
            },

            error: function(error) {
                console.error('Error displaying summary:', error);
            }
        });
    }

    function updateCartCount(){
        $.ajax({
            url: wemake.ajax_url, 
            type: 'GET',
            data: {
                action: 'get_cart_count', 
                _wpnonce: wemake.nonce,
            },
            success: function(response){
                if (response.data == 0){
                    window.location.href = '/offertemand-leeg';
                }
                else{
                    $('.offerte-counter__count').text(response.data);
                }
            },
        });
    }


    $(document).on('change', '.cart__item .cart__item-qty', function(){
        let qty = $(this).val();
        let id = $(this).closest('.cart__item').data('id');

        $.ajax({
            url: wemake.ajax_url, 
            type: 'POST',
            data: {
                action: 'update_cart_item', 
                id: id,
                key: 'qty',
                value: qty,
                _wpnonce: wemake.nonce,
            },
            success: function(response){
                console.log(response.data);
                $('.offerte-counter__count').text(response.data.total_count);
                let totalCountText = response.data.total_count == 1 ? `${response.data.total_count} product` : `${response.data.total_count} producten`;
                $('.cart__total-count').text(totalCountText);
                updateCartSummary();
            },
            error: function(error) {
                console.error('Error updating qty:', error);
            }
        });
    });

        
    // Verwijder het product. User zit in de popup en klikt op verwijder product.
    $(document).on('click', '.popup-remove__verwijder', function(){
        let id = $(this).closest('#popup-verwijder-product').attr('data-id');

        $.ajax({
            url: wemake.ajax_url, 
            type: 'POST',
            data: {
                action: 'remove_from_cart', 
                id: id,
                _wpnonce: wemake.nonce,
            },

            success: function(response){
                console.log(response.data);
                if (response.data.total_count == 0){
                    window.location.href = '/offertemand-leeg';
                    return;
                }

                $('.offerte-counter__count').text(response.data.total_count);
                $('.cart__item[data-id="' + id + '"]').remove();
                

                let totalCountText = response.data.total_count == 1 ? `${response.data.total_count} product` : `${response.data.total_count} producten`;
                $('.cart__total-count').text(totalCountText);

                updateCartSummary();
                updateCartControls();
                updateCartTitle();
            },

            error: function(error) {
                console.error('Error removing product:', error);
            }
        });
    });




    // Wijzig product 
    $(document).on('click', '.cart__item .cart__wijzig', function(){
        let url = $(this).data('url');
        let id = $(this).closest('.cart__item').data('id');

        let newUrl = url + "?id=" + id;

        window.location.href = newUrl;
    });


    // Verander montage alle producten optie
    $(document).on('click', '.cart__item .cart__item-montage-alles', function(){
        let input = $(this).find('input');

        if (input.is(':checked')){
            $('input[name="montage-alles"]').prop('checked', true);
            $('.cart__montage').addClass('disabled');
        }
        else{
            $('.cart__montage').removeClass('disabled');
            $('input[name="montage-alles"]').prop('checked', false);
        }

        // For all products in the cart. Update the montage to ja.
        if (input.is(':checked')){
            $('.cart__item[data-standaardmaat="0"][data-montage-verplicht="0"]').each(function(){
                let id = $(this).data('id');
                $.ajax({ 
                    url: wemake.ajax_url, 
                    type: 'POST',
                    data: {
                        action: 'update_cart_item', 
                        id: id,
                        key: 'montage',
                        value: 1,
                        _wpnonce: wemake.nonce,
                    },
                    success: function(response){
                        console.log(response.data);
                    },
                    error: function(error) {
                        console.error('Error updating montage:', error);
                    }
                });
            }); 
        }
        else{
            // Change to the individually selected
            $('.cart__item[data-standaardmaat="0"][data-montage-verplicht="0"]').each(function(){
                let id = $(this).data('id');
                let montage = $(this).find('.cart__montage input[type="radio"]:checked').val();

                $.ajax({
                    url: wemake.ajax_url, 
                    type: 'POST',
                    data: {
                        action: 'update_cart_item', 
                        id: id,
                        key: 'montage',
                        value: montage,
                        _wpnonce: wemake.nonce,
                    },
                    success: function(response){
                        console.log(response.data);
                    },
                    error: function(error) {
                        console.error('Error updating montage:', error);
                    }
                });
                     
            }); 
        }
    });


    // Montage radio switch
    $(document).on('click', '.cart__item .cart__montage input[type="radio"]', function(){
        let id = $(this).closest('.cart__item').data('id');
        let value = $(this).val();
        $.ajax({
            url: wemake.ajax_url, 
            type: 'POST',
            data: {
                action: 'update_cart_item', 
                id: id,
                key: 'montage',
                value: value,
                _wpnonce: wemake.nonce,
            },
            success: function(response){
                console.log(response.data);
            },
            error: function(error) {
                console.error('Error updating montage:', error);
            }
        });
    });

    $(document).on('change', '.cart__item .cart__ref', function(){
        let id = $(this).closest('.cart__item').data('id');
        let value = $(this).val();
        $.ajax({
            url: wemake.ajax_url, 
            type: 'POST',
            data: {
                action: 'update_cart_item', 
                id: id,
                key: 'referentie',
                value: value,
                _wpnonce: wemake.nonce,
            },
            success: function(response){
                console.log(response.data);
            },
            error: function(error) {
                console.error('Error updating ref:', error);
            }
        });
    });

    $(document).on('click', '.cart__item-opties--extend', function(){
        if (!$(this).hasClass('active')){
            $(this).siblings('.cart__item-opties').removeClass('hidden-small');
            $(this).addClass('active');
            $(this).text('Verberg specificaties');
        }else{
            $(this).siblings('.cart__item-opties').addClass('hidden-small');
            $(this).removeClass('active');
            $(this).text('Toon specificaties');
        }
    });


    /* Aangepast product popup */
    function generateUniqueId() {
        return Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
    }

    let data = {};

    $('[data-popup="popup-aangepast-product"]').on('click', function(){
        data = {
            'id' : generateUniqueId(),
            'qty' : 1,
            'productId' : 0,
            'productNaam' : 'Eigen ontwerp',
            'productCategory' : 'eigen-ontwerp',
            'productFotoUrl' : $('.cart').data('aangepast-product-img'),
            'opties' : {},
            'montage' : 0,
            'info' : '',
            'standaardmaat' : 0
        } 
    });


    $('textarea[name="extra-informatie"]').on('change', function(){
        data['info'] = $(this).val();
    });


    $('.add-to-cart').on('click', function(e) {
        $('textarea[name="extra-informatie"]').val('');
        e.preventDefault();
       
        // Assuming `data` is defined earlier in your script
        $.ajax({ 
            url: wemake.ajax_url,
            type: 'POST',
            data: {
                action: 'add_to_cart', 
                data: data,
                _wpnonce: wemake.nonce,
            },
            success: function(response) {
                $('.offerte-counter__count').text(response.data.total_count);
                console.log(response.data);
    
                var productId = data.productId; 
                var productTitle = data.productNaam; 
                var id = data.id;
                var info = data.info;
                var productImg = $('.cart').data('aangepast-product-img');
                
                // Create the HTML for the new cart item dynamically based on response data
                var newCartItem = `
                    <div class="cart__item p-r d-f b-white br-16 gap-20 fade-in in-view" data-product-id="${productId}" data-id="${id}">
                        <div class="d-f gap-15 cart__change t-13 hidden-small">
                            <span class="cart__verwijder open-popup" data-popup="popup-verwijder-product">Verwijder</span>
                        </div>
                        <div class="flex-33 flex-100-s cart__item-image d-f gap-20">
                            <strong class="small-label t-12 t-c-gold d-if gap-5 f-a-c">
                                <img width="7" height="7" src="/wp-content/themes/wemake/images/dot-gold.svg" alt="">Eigen ontwerp
                            </strong>
                            <img width="610" height="400" src="${productImg}" class="br-16 wp-post-image cover" alt="vandijk aangepast product" decoding="async" fetchpriority="high">
                        </div>
                        <div class="flex-grow d-f fd-c gap-15">
                            <h5 class="cart__item-title m-0">${productTitle}</h5>
                            <textarea class="cart__item-info" rows="8" name="info" id="extra-informatie" style="width: 463px; height: 189px;">${info}</textarea>
                        </div>
                    </div>`;
    
                $('.cart').prepend(newCartItem);

                updateCartSummary();
                updateCartControls();
                updateCartTitle();
            },
            error: function(error) {
                console.error('Error adding product to cart:', error);
            }
        });
    });      
    
    /* Eigen product */

    // Info voor eigen product
    $(document).on('change', '.cart__item .cart__item-info', function(){
        let val = $(this).val();
        let id = $(this).closest('.cart__item').data('id');

        $.ajax({
            url: wemake.ajax_url, 
            type: 'POST',
            data: {
                action: 'update_cart_item', 
                id: id,
                key: 'info',
                value: val,
                _wpnonce: wemake.nonce,
            },
            success: function(response){
                console.log(response.data);
                $('.offerte-counter__count').text(response.data.total_count);
            },
            error: function(error) {
                console.error('Error updating info:', error);
            }
        });
    });

    /*  
        Verwijder
    */
    // Fill up the verwijder-popup with the values of the 
    // item where 'verwijder' was clicked.
    $(document).on('click', '.cart__verwijder', function() {
        let $item = $(this).closest('.cart__item');
        let $popup = $('#popup-verwijder-product');
        let title = $item.find('.cart__item-title').text();
        let qty = $item.find('.cart__item-qty').val();
        let opties = $item.find('.cart__item-opties').clone();
        opties.removeClass('hidden-small');
        let thumbnail = $item.find('.cart__item-image img').attr('src');
        let id = $item.data('id');
        let productId = $item.data('product-id');
        let info = $item.find('.cart__item-info').val();
        
        // Geen eigen ontwerp
        if (productId != 0){
            $popup.attr('data-id', id);
            $popup.find('.popup-remove__title').contents().filter(function() {
                return this.nodeType === Node.TEXT_NODE;
            }).first().replaceWith(title);
            $popup.find('.popup-remove__qty').contents().filter(function() {
                return this.nodeType === Node.TEXT_NODE;
            }).first().replaceWith(qty);
            $popup.find('.popup-remove__opties-wrap-content').empty();
            $popup.find('.popup-remove__opties-wrap-content').append(opties);
            $popup.find('.popup-remove__image').attr('src', thumbnail);
        
        }
        // Eigen ontwerp
        else {
            $popup.attr('data-id', id);
            $popup.find('.popup-remove__title').contents().filter(function() {
                return this.nodeType === Node.TEXT_NODE;
            }).first().replaceWith(title);
            $popup.find('.popup-remove__opties-wrap-content').empty();
            $popup.find('.popup-remove__opties-wrap-content').append(info);
            $popup.find('.popup-remove__image').attr('src', thumbnail);
        }
    });


    $(document).on('click', '.cart__filter', function(e) {
        e.stopPropagation();
    
        let $this = $(this);
        let isActive = $this.hasClass('active');
    
        if (!isActive) {
            $this.addClass('active');
        }
    });
    
    $(window).on('click', function() {
        $('.cart__filter').removeClass('active');
    });

    $(document).on('click', '.cart__filter-options', function(e) {
        e.stopPropagation();
    });

    
    $(document).on('click', '.cart__filter-option', function(e) {
        let $this = $(this);
        let value = $this.data('value');
    
        // Update UI
        $('.cart__filter-selected').text($this.data('name'));
        $('.cart__filter-option').removeClass('active');
        $this.addClass('active');
    
        // Filter items
        $('.cart__item').each(function() {
            let $item = $(this);
            let isStandaard = $item.data('standaardmaat') == 1;
    
            if (value === 'all') {
                $item.show();
            } else if (value === 'standaardmaat' && isStandaard) {
                $item.show();
            } else if (value === 'maatwerk' && !isStandaard) {
                $item.show();
            } else {
                $item.hide();
            }
        });
    
        // Close the dropdown
        $('.cart__filter').removeClass('active');
    });


    $(document).on('click', '.cart__verberg-details', function(){
        let input = $(this).find('input');

        if (input.is(':checked')){
            $('.cart__item-opties-wrap').addClass('hidden');
        }
        else{
            $('.cart__item-opties-wrap').removeClass('hidden');
        }
    });

    // Snelweergave (quick view) voor cart item
    $(document).on('click', '.cart__snelweergave', function() {
        let $cartItem = $(this).closest('.cart__item');
        let id = $cartItem.data('id');
        let popupContent = $('#popup-snelweergave .popup-snelweergave__content');
        let popupFooter = $('#popup-snelweergave .popup-snelweergave__footer');

        $.ajax({
            url: wemake.ajax_url,
            type: 'POST',
            data: {
                action: 'get_product_snelweergave_html',
                id: id,
                _wpnonce: wemake.nonce,
            },
            beforeSend: function(){
                popupContent.html('<div class="spinner-loader"></div>');
                popupFooter.html(''); 
            },
            success: function(response) {
                if (response.success) {
                    popupContent.html(response.data.content);
                    popupFooter.html(response.data.footer);
                } else {
                    console.error('Fout bij ophalen productinformatie:', response.data);
                }
            },
            error: function(error) {
                console.error('AJAX fout:', error);
            }
        });
    });

    $(document).on('click', '.cart__snelweergave', function() {
        let $cartItem = $(this).closest('.cart__item');
        let id = $cartItem.data('id');
        let popupContent = $('#popup-snelweergave .popup-snelweergave__content');
        let popupFooter = $('#popup-snelweergave .popup-snelweergave__footer');

        $.ajax({
            url: wemake.ajax_url,
            type: 'POST',
            data: {
                action: 'get_product_snelweergave_html',
                id: id,
                _wpnonce: wemake.nonce,
            },
            beforeSend: function(){
                popupContent.html('<div class="spinner-loader"></div>');
                popupFooter.html(''); 
            },
            success: function(response) {
                if (response.success) {
                    popupContent.html(response.data.content);
                    popupFooter.html(response.data.footer);
                } else {
                    console.error('Fout bij ophalen productinformatie:', response.data);
                }
            },
            error: function(error) {
                console.error('AJAX fout:', error);
            }
        });
    });

    if (new Date().getDay() === 0){
        
    }

    


});